import { useParams } from "react-router-dom";
import { Map, MapMarker } from "react-kakao-maps-sdk";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import {pageMenuTabList01} from 'types/common';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

export default function Location() {
  const { id } = useParams<{ id: string }>();
  
  pageMenuTabList01[3].on = true;

  const locations = [
    {
      id: 'seoul',
      name: '서울 사업장',
      address: '서울특별시 종로구 새문안로 5길 19 13층 (당주동 5, 로얄빌딩)',
      lat: 37.571990549144914,
      lng: 126.9743209460398,
    },
    {
      id: 'busan',
      name: '부산 본사',
      address: '부산광역시 부산진구 중앙대로 770 2층 (부전동, 고촌빌딩)',
      lat: 35.160841440327054,
      lng: 129.0619380058879,
    },
    {
      id: 'yangsan',
      name: '양산 생산본부',
      address: '경상남도 양산시 매곡동 997-1 (매곡동)',
      lat: 35.36299577621046,
      lng: 129.17224163634026,
    },
  ];

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/map-hero_1920x1080.jpg.jpg" imgText="오시는 길" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList01}></PageTab>
      <div className="location container">

        <div className="container-title">
          천호엔케어 <span className="highlight">사업장 소개</span>
        </div>

        {locations.map((location) => (
          <div className="location-item" key={location.id}>
            <div className="location-map">
              <Map center={{ lat: location.lat, lng: location.lng }} className="map" >
                <MapMarker position={{ lat: location.lat, lng: location.lng }}>
                </MapMarker>
              </Map>
            </div>
            <div className="location-info">
              <div className="location-name">{location.name}</div>
              <div className="location-address"><FontAwesomeIcon icon={faLocationDot} /> {location.address}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
